<template>

<b-modal ref="bModal" @ok="$emit('save', client)" @hidden="onHidden" title="Editar Client" size="lg"
         header-bg-variant="primary" header-text-variant="light" ok-title="Guardar">
  <client-form v-model="client"/>
</b-modal>

</template>

<script>

import ClientForm from './ClientForm'

export default {
  name: 'EditClientModal',
  components: {ClientForm},
  data() {
    return {
      client: {}
    }
  },
  methods: {
    show(client) {
      this.client = {...client}
      this.$refs.bModal.show()
    },
    onHidden() {
      this.client = {}
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/client/EditClientModal.vue